import gsap from 'gsap'

export const createIntroTimeline = (
  rootEl: HTMLElement,
  onComplete: () => void,
  isAppReady: boolean
) => {
  if (!rootEl) return

  const logoLetters = rootEl.querySelectorAll('.lx-logo span')
  const counterValue = rootEl.querySelector('.counter-value')
  const counterLabel = rootEl.querySelector('.counter-label')
  const portalRing = rootEl.querySelector('.lx-portal-ring')
  const glowBar = rootEl.querySelector('.glow-bar') as SVGGeometryElement | null

  if (!logoLetters.length || !portalRing) {
    onComplete()
    return
  }

  // حساب طول شريط التحميل
  let circumference = 578
  if (glowBar && typeof glowBar.getTotalLength === 'function') {
    try {
      circumference = glowBar.getTotalLength()
    } catch (e) {}
  }

  if (glowBar) {
    gsap.set(glowBar, {
      strokeDasharray: circumference,
      strokeDashoffset: circumference,
    })
  }

  const tl = gsap.timeline()

  // 1️⃣ إعداد العناصر في وضعها المبدئي
  tl.set(logoLetters, { opacity: 0, y: 30, scale: 0.8, rotateX: -90 })
    .set(portalRing, { width: 0, height: 0, opacity: 0 })

  // 2️⃣ التوسع التدريجي للبوابة الدائرية (1.5 ثانية)
  tl.to(portalRing, {
    width: 440,
    height: 440,
    opacity: 1,
    duration: 1.5,
    ease: 'power3.out',
  })

  // 3️⃣ تشغيل العداد بسلاسة فائقة من 0 إلى 100 بدون انقطاع (مدة 3.5 ثانية)
  const counterObj = { value: 0 }
  tl.to(
    counterObj,
    {
      value: 100,
      duration: 3.8, // مدة كافية لامتصاص تحميل الصفحة الرئيسية
      ease: 'power2.inOut',
      onUpdate: () => {
        const val = Math.round(counterObj.value)
        if (counterValue) {
          counterValue.textContent = val.toString().padStart(3, '0')
        }
        if (glowBar) {
          const progress = val / 100
          gsap.set(glowBar, {
            strokeDashoffset: circumference * (1 - progress),
          })
        }
      },
    },
    '<=0.3' // يبدأ العداد فور بداية فتح البوابة
  )

  // 4️⃣ ظهور حروف BADANIBEX بالتدريج وبسلاسة أثناء حركة العداد
  tl.to(
    logoLetters,
    {
      opacity: 1,
      y: 0,
      scale: 1,
      rotateX: 0,
      duration: 1.0,
      stagger: 0.08,
      ease: 'back.out(1.2)',
    },
    '-=3.0'
  )

  // 5️⃣ التأكد من وصول العداد لـ 100% ثم فتح الستارة والخروج للرئيسية
  tl.to([counterValue, counterLabel], {
    opacity: 0,
    duration: 0.4,
    delay: 0.3,
  })
  .to(logoLetters, {
    opacity: 0,
    scale: 1.1,
    duration: 0.5,
    ease: 'power2.in',
  }, '-=0.2')
  .to(portalRing, {
    width: '180vmax',
    height: '180vmax',
    duration: 1.2,
    ease: 'expo.inOut',
  }, '-=0.3')
  .to(rootEl, {
    clipPath: 'circle(0% at 50% 50%)',
    duration: 0.9,
    ease: 'power4.inOut',
    onComplete: () => {
      onComplete()
    },
  }, '-=0.7')

  return tl
}